import { useTheme } from './useTheme';

/**
 * Side-effect-only component: mounts the theme tick + applies <html data-theme>.
 * Mount once near the app root.
 */
export default function ThemeApplier() {
  useTheme();
  return null;
}
